/**
 * LightboxDialog — visionneuse plein écran d'une image sans rognage.
 *
 * Utilise le Dialog shadcn pour l'accessibilité clavier (Esc pour fermer).
 * L'image s'adapte à la fenêtre (max-w/h) tout en conservant son ratio naturel.
 *
 * Props:
 *  - open, onOpenChange (contrôlé)
 *  - src (URL de l'image)
 *  - alt (texte alt)
 *  - caption (optionnel, légende affichée en bas)
 */
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { X } from "lucide-react";

export default function LightboxDialog({ open, onOpenChange, src, alt = "", caption = "" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[95vw] w-fit p-0 border-0 bg-black/95 shadow-2xl"
        data-testid="lightbox-dialog"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogTitle className="sr-only">{alt || "Image agrandie"}</DialogTitle>
        <DialogDescription className="sr-only">
          {caption || "Appuyez sur Échap pour fermer."}
        </DialogDescription>
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          className="absolute right-2 top-2 z-10 rounded-full bg-black/60 p-2 text-white transition hover:bg-black/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
          aria-label="Fermer"
          data-testid="lightbox-close"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex flex-col items-center justify-center">
          {src && (
            <img
              src={src}
              alt={alt}
              className="max-h-[92vh] max-w-[95vw] h-auto w-auto object-contain select-none"
              draggable={false}
              data-testid="lightbox-image"
            />
          )}
          {caption && (
            <div className="w-full px-4 py-3 text-center text-xs text-white/80" data-testid="lightbox-caption">
              {caption}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
